import React from 'react';
import { FilterX } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
import { Button } from './ui/button';
import { ButtonTooltip, TooltipProvider } from './ui/tooltip';

interface ClearFiltersButtonProps {
  enabled: boolean;
  onClick: () => void;
  className?: string;
}

export const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({
  enabled,
  onClick,
  className,
}) => {
  const { t } = useLocale();
  const tooltip = t('clear_filters_tooltip');

  return (
    <TooltipProvider delayDuration={0}>
      <ButtonTooltip tooltip={tooltip} side="bottom">
        <span className="inline-flex shrink-0">
          <Button
            type="button"
            variant="outline"
            size="icon"
            className={className ?? 'h-9 w-9 shrink-0'}
            disabled={!enabled}
            onClick={onClick}
            aria-label={tooltip}
          >
            <FilterX className="h-4 w-4" />
          </Button>
        </span>
      </ButtonTooltip>
    </TooltipProvider>
  );
};
